import ContactUs from '@/domains/ContactUs';
import { PageLayout } from '../widgets';

const ContactUsPage = (): JSX.Element => {
  return (
    <PageLayout>
      <ContactUs />
    </PageLayout>
  );
};

export default ContactUsPage;

// import { Hero, PartnerWithUsForm, Careers } from '@/domains/ContactUs';

// import { PageLayout } from '../widgets';

// const ContactUsPage = (): JSX.Element => {
//   return (
//     <PageLayout>
//       <Hero />
//       <PartnerWithUsForm />
//       <Careers />
//     </PageLayout>
//   );
// };

// export default ContactUsPage;
